<app-header [header-data]="headerData"></app-header>
<div class="about-container container-md px-md-0">
    <h2 class="about-title">{{labelCaption['AU_Title']}}</h2>

    <div class="row no-gutters">
        <div class="col-12 about-content">
            <p [innerHtml]="labelCaption['AU_Content']"></p>
        </div>
        <div class="col-12 col-md-6">
            <button type="button" (click)="onClickToRedirectToHome()"
                class="secondary-button">{{labelCaption['AU_HOME']}}</button>
        </div>
    </div>

</div>